import { render, staticRenderFns } from "./Wins.vue?vue&type=template&id=179f9a20&scoped=true"
import script from "./Wins.vue?vue&type=script&lang=js"
export * from "./Wins.vue?vue&type=script&lang=js"
import style0 from "./Wins.vue?vue&type=style&index=0&id=179f9a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f9a20",
  null
  
)

export default component.exports